<ng-container *ngIf="!isResetConfirmed">
    <div class="preauth-container">
        <tm1-typography type = "title-page">Reset Password</tm1-typography>
        <br/>
        <ng-container *ngIf="error !== ''">
            <tm1-banner variant = "error">{{error}}</tm1-banner>
            <br/>
        </ng-container>
        <tm1-card variant = "shadow" class = "card-container">
        <label for="email">Enter your email address:</label>
        <input class="form-control" type="email" id="email" [(ngModel)]="email" name="email" required />
        <tm1-button (click) = "sendResetCode()" [disabled]="!email">Send Reset Code</tm1-button>
   </tm1-card>
    </div>
</ng-container>
  
    <ng-container *ngIf="isResetConfirmed">
    <div class="preauth-container">
        <tm1-typography type = "title-page">Reset Password</tm1-typography>
        <br/>
        <ng-container *ngIf="error !== ''">
            <tm1-banner variant = "error">{{error}}</tm1-banner>
            <br/>
        </ng-container>
        <tm1-card variant = "shadow" class = "card-container">
            <tm1-banner>You have been emailed a reset password code. Please enter it below along with your new password.</tm1-banner>
            <label for="code">Reset Code:</label>
        <input class="form-control" type="text" id="code" [(ngModel)]="code" name="code" required />
        <label for="newPassword">New Password:</label>
        <input class="form-control" type="password" id="newPassword" [(ngModel)]="newPassword" name="newPassword" required />
        <tm1-button (click) = "confirmResetPassword()" [disabled]="!code || !newPassword">Submit New Password</tm1-button>
    </tm1-card>
    </div>
    </ng-container>

  